"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.gameVendorSettingsProviderActions = exports.initialState = void 0;
const slices_1 = require("../../utils/@reduxjs/slices");
const toolkit_1 = require("../../utils/@reduxjs/toolkit");
const api_1 = require("../../utils/api");
const REDUCER_KEY = 'gameVendorSettings';
// The initial state of the gameVendorSettingsProvider container
exports.initialState = (0, slices_1.getPreloadedState)(REDUCER_KEY, {
    gameVendorSettings: {},
    fetchItems: api_1.requestInitialState,
});
const gameVendorSettingsProviderSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        fetchGameVendorSettings(state) {
            state.fetchItems.loading = true;
            state.fetchItems.error = null;
        },
        fetchGameVendorSettingsSuccess(state, { payload }) {
            if (payload.items) {
                state.gameVendorSettings = payload.items.reduce((a, i) => ({ ...a, [i.gameVendor]: i.available }), {});
            }
            state.fetchItems.loading = false;
            state.fetchItems.error = null;
        },
        fetchGameVendorSettingsError(state, { payload }) {
            state.fetchItems.loading = false;
            state.fetchItems.error = payload;
        },
    },
});
exports.gameVendorSettingsProviderActions = gameVendorSettingsProviderSlice.actions, exports.reducer = gameVendorSettingsProviderSlice.reducer, exports.sliceKey = gameVendorSettingsProviderSlice.name;
//# sourceMappingURL=slice.js.map